import { GenderToGenderIdMap, Module } from 'src/domain';
import { useGender } from './useGender';

export const useGenderId = (module?: Module) => {
    const gender = useGender(module);

    return GenderToGenderIdMap.get(gender);
};
